import { render, staticRenderFns } from "./kpjl.vue?vue&type=template&id=c2a83a34&scoped=true"
import script from "./kpjl.vue?vue&type=script&lang=js"
export * from "./kpjl.vue?vue&type=script&lang=js"
import style0 from "./kpjl.vue?vue&type=style&index=0&id=c2a83a34&prod&scoped=true&lang=scss"
import style1 from "./kpjl.vue?vue&type=style&index=1&id=c2a83a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a83a34",
  null
  
)

export default component.exports